import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="relative bg-[#0A0A0A] text-[#FDFBF7] pt-24 md:pt-32 pb-10 overflow-hidden grain" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.h3
          initial={{ y: 60, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif font-light text-[16vw] md:text-[13vw] leading-[0.85] tracking-tighter"
        >
          Let&apos;s <em className="text-[#FF5722]">talk.</em>
        </motion.h3>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-white/10 pt-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-[#FF5722]" />
              <span className="font-serif text-2xl">
                Photo Booth <em className="not-italic text-[#FF5722]">Memories</em>
              </span>
              <span className="overline ml-2 opacity-70">L.L.C</span>
            </div>
            <p className="mt-5 max-w-md text-[#FDFBF7]/70 text-sm leading-relaxed">
              Don&apos;t just rent a booth — give your guests something to remember. Family-run mirror photo booth studio
              for weddings, quinces &amp; celebrations across Chicagoland.
            </p>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[#FDFBF7]/60 mb-4">Contact</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a className="hover:text-[#FF5722]" href="mailto:photoboothmemories2024@gmail.com">
                  photoboothmemories2024@gmail.com
                </a>
              </li>
              <li>
                George — <a className="hover:text-[#FF5722]" href="tel:+17089403182">(708) 940 · 3182</a>
              </li>
              <li>
                Lucy — <a className="hover:text-[#FF5722]" href="tel:+17087699419">(708) 769 · 9419</a>
              </li>
              <li>Chicagoland, IL</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[#FDFBF7]/60 mb-4">Follow</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  className="inline-flex items-center gap-2 hover:text-[#FF5722]"
                  href="https://www.instagram.com/photo_booth_memories?igsh=dGxyd2NjNnhlaWtk&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-instagram"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                  </svg>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  className="inline-flex items-center gap-2 hover:text-[#FF5722]"
                  href="https://www.facebook.com/profile.php?id=61566617068479&mibextid=wwXIfr&mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-facebook"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                  </svg>
                  Facebook
                </a>
              </li>
              <li>
                <a
                  className="inline-flex items-center gap-2 hover:text-[#FF5722]"
                  href="https://www.tiktok.com/@photo_booth_memories7?_r=1&_t=ZT-98KWzUI3AI1"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-tiktok"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M19.5 6.6a5.6 5.6 0 0 1-3.7-1.4 5.6 5.6 0 0 1-1.7-3.2h-3.3v13.1a2.7 2.7 0 1 1-2-2.6V9.1a5.9 5.9 0 1 0 5.3 5.9V9.7a8.7 8.7 0 0 0 5.4 1.8V8.2c0-.5 0-1-.1-1.6z" />
                  </svg>
                  TikTok
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[#FDFBF7]/60 mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a className="hover:text-[#FF5722]" href="#portfolio">
                  Archive
                </a>
              </li>
              <li>
                <a className="hover:text-[#FF5722]" href="#packages">
                  Packages
                </a>
              </li>
              <li>
                <a className="hover:text-[#FF5722]" href="#booking">
                  Reserve
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline text-[#FDFBF7]/60 mb-4">Team</div>
            <a href="/admin/login" className="text-sm hover:text-[#FF5722]" data-testid="admin-portal-link">
              Studio portal →
            </a>
          </div>
        </div>

        <div className="mt-16 flex items-center justify-between text-xs text-[#FDFBF7]/50">
          <span>© {new Date().getFullYear()} Photo Booth Memories L.L.C. All rights reserved.</span>
          <span>Built with care.</span>
        </div>
      </div>
    </footer>
  );
}
